import {
  FormattedMessage,
  useIntl,
} from 'react-intl';

import { globalMessages } from '@/core/messages/global.messages';
import {
  IconButton,
  IconButtonSizes,
} from '@/core/components/IconButton';
import { ButtonVariant } from '@/core/components/Button';
import {
  Linkedin,
  X,
} from '@/core/components/Icons';
import { useTheme } from '@/core/hooks/useTheme';

import {
  Text,
  Wrapper,
} from './SocialShare.styles';

type SocialShareProps = {
  link: string;
}

export const SocialShare = ({ link }: SocialShareProps) => {
  const { colors } = useTheme();
  const { formatMessage } = useIntl();

  return (
    <Wrapper>
      <Text>
        <FormattedMessage {...globalMessages.share} />
      </Text>
      <IconButton
        icon={<Linkedin fill={colors.black} />}
        size={IconButtonSizes.SMALL}
        variant={ButtonVariant.SECONDARY}
        renderAs="a"
        target="_blank"
        href={`https://www.linkedin.com/shareArticle?url=${link}`}
        ariaLabel={`${formatMessage(globalMessages.share)} Linkedin`}
      />
      <IconButton
        icon={<X fill={colors.black} />}
        size={IconButtonSizes.SMALL}
        variant={ButtonVariant.SECONDARY}
        renderAs="a"
        target="_blank"
        href={`https://twitter.com/intent/tweet?url=${link}`}
        ariaLabel={`${formatMessage(globalMessages.share)} Twitter`}
      />
    </Wrapper>
  );
};
